import type { MailboxInfo } from 'owa-client-types';
import { getStore } from '../store/store';
import { makeEmptyAccountConfiguration } from './makeEmptyAccountConfiguration';
import type { AdditionalAccountConfiguration } from '../store/schema/OwaSessionStore';

export const getSharedMailboxFolderInformationMap = (
    mailboxInfo: MailboxInfo
): AdditionalAccountConfiguration | undefined => {
    const store = getStore();
    return store.sharedMailboxFolderInformationMaps.get(mailboxInfo.mailboxSmtpAddress);
};

export const initializeSharedMailboxFolderInformationMap = (mailboxInfo: MailboxInfo): void => {
    const store = getStore();
    const sharedMailboxMap = makeEmptyAccountConfiguration();
    store.sharedMailboxFolderInformationMaps.set(mailboxInfo.mailboxSmtpAddress, {
        ...sharedMailboxMap,
    });
};

export const getOrInitializeSharedMailboxFolderInformationMap = (
    mailboxInfo: MailboxInfo
): AdditionalAccountConfiguration | undefined => {
    const sharedMailboxMap = getSharedMailboxFolderInformationMap(mailboxInfo);
    if (!sharedMailboxMap) {
        initializeSharedMailboxFolderInformationMap(mailboxInfo);
    }
    return getSharedMailboxFolderInformationMap(mailboxInfo);
};
